import React from 'react';
import "./Contact.css";
import { RiSendPlaneFill } from "react-icons/ri"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Fade from 'react-reveal/Fade';
//import emailjs from 'emailjs-com';
import { useRef } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {

    const toast_not = () =>{
         
    toast("Email sent Sucessfully")
    }

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_6c2vpda', 'template_7uav4jp', form.current, 'bC-K16AM7ZNbeg7F6')
          .then((result) => {
              console.log(result.text);
          },
          (error) => {
              console.log(error.text);
          });
          e.target.reset()
      };

    const form = useRef()


    return (
        <div className='container contact-section' id="contactsection">
            <div className='row'>
                <Fade bottom>
                    <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5" >
                        <div className='contact-form-image'>
                            <img src="https://images.pexels.com/photos/4348403/pexels-photo-4348403.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                                alt="contact form image" />
                        </div>
                    </div>
                </Fade>
                <Fade right>
                    <div className="col-xl-7 col-lg-7 col-md-7 col-sm-7"  >
                        <div className='contact-form-design'>
                            <div className='text-center'>
                                <h5>
                                    Contact Me
                                </h5>
                            </div>
                            <form ref={form} onSubmit={sendEmail}>
                                <div className="contact-form">
                                    <label className='form-laber'>Name</label>
                                    <input type="text" name="name"  className='form-control' required/>

                                </div>
                                <div className="contact-form">
                                    <label className='form-laber'>E-mail</label>
                                    <input type="text" name='user-mail' className='form-control' required/>

                                </div>
                                <div className="contact-form">
                                    <label className='form-laber'>Job Types</label>
                                    <select className='custom-select-tag' name='job_type' required>
                                        <option  name='job_type'>Full Time</option>
                                        <option  name='job_type'>Part Time</option>
                                        <option  name='job_type'>Internship</option>
                                        <option  name='job_type'>Working Student</option>
                                        <option  name='job_type'>Contract</option>
                                    </select>

                                </div>
                                <div className="contact-form">
                                    <label className='form-laber'>Message</label>
                                    <textarea rows="4" type="text" name="message" className='form-control' />

                                </div>
                                <div className='button-submit'>
                                <button className="button-submi1t" onSubmit={sendEmail} onClick={toast_not} >
                                    <p>
                                        Send <RiSendPlaneFill size={20} />
                                    </p>
                                </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </Fade>
            </div><ToastContainer autoClose={8000}/>
        </div>
    );
};
export default Contact;